import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import i18n from '../../../i18n/i18next'

interface IAmenitiesProps {
    amenities: string[]
}

const amenitiesMap = {
    Parking: 'Parking',
    'WiFi/Internet': 'Wifi',
    '24/7 front desk': 'Okay',
    Elevator: 'Okay',
    'Pet friendly': 'Okay',
    Kitchen: 'Okay',
    Gym: 'Okay',
    Pool: 'Okay',
    Laundry: 'Okay',
    'Business center': 'Okay',
    'Airport Shuttle': 'Bus',
    'Non-smoking': 'Okay',
    'Meeting rooms': 'Okay',
    Restaurant: 'Okay',
    Breakfast: 'Okay',
    Spa: 'Okay',
    'Air conditioning': 'Okay',
}

export const HotelAmenities = ({ amenities }: IAmenitiesProps) => {
    return (
        <Stack>
            <Typography variant="bodyBold">
                {i18n.t('booking.amenities')}
            </Typography>
            <Box display={'grid'} gridTemplateColumns={'auto auto'}>
                {amenities.map((amenity, index) => (
                    <Box key={'amenityItem' + index}>
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems={'center'}
                        >
                            <Icon
                                iconColour={ColoursObj.core.secondary}
                                name={amenitiesMap[amenity] ?? 'Okay'}
                            />
                            <Typography variant="bodySubtext">
                                {amenity}
                            </Typography>
                        </Stack>
                    </Box>
                ))}
            </Box>
        </Stack>
    )
}
